import { React, useEffect, useState } from "react";
import "./Nav.css";
import { Link } from "react-scroll";
import logoLight from "../../image/1Ysr-R03-0VI-Icon-أصلها ثابت-Vector-05.png";
import logoDark from "../../image/1Ysr-R03-0VI-Icon-أصلها ثابت-Vector (1).png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Nav = (props) => {
  const [activeviwo, setactiveviwo] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [truedark, setTrueDark] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ShowSide, setShowSide] = useState(false);
  const isMobile = props.isMobile || false;

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 100);

    function handleScroll() {
      const isScrolled = window.scrollY > 40;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const teggleMenu = () => {
    setShowSide(!ShowSide);
  };

  const setDarkMode = () => {
    document.querySelector("body").setAttribute("data-theme", "dark");
  };

  const setLightMode = () => {
    document.querySelector("body").setAttribute("data-theme", "light");
  };

  const toggelemode = (e) => {
    if (e.target.checked) {
      setDarkMode();
      setTrueDark(true);
      props.setTrueDarkMode(true);
    } else {
      setLightMode();
      setTrueDark(false);
      props.setTrueDarkMode(false);
    }
  };

  // ✅ التعديل هنا: إغلاق القائمة عند الضغط على أي رابط
  const handleNavClick = () => {
    if (ShowSide) {
      setShowSide(false);
    }
  };

  return (
    <header
      className={`header ${scrolled ? "scrolled" : ""} ${
        isMobile ? "mobile" : "desktop"
      }`}
    >
      <Link
        to="Home"
        className="Logo"
        spy={true}
        smooth={true}
        offset={-100}
        duration={200}
        onClick={handleNavClick}
      >
        {loading ? (
          <img src={truedark ? logoLight : logoDark} alt="Logo" />
        ) : (
          <Skeleton circle width={40} height={40} />
        )}
      </Link>

      <i
        className={`bx ${isMobile ? "bx-menu-alt-left" : "bx-menu"} menu-icon`}
        onClick={teggleMenu}
        id="menu_icon"
      ></i>

      <nav className={`navbar ${ShowSide ? "active" : ""}`}>
        <i className="bx bx-x close" onClick={() => setShowSide(false)}></i>

        {["Home", "About", "Skills", "Blog", "Services", "Contact"].map(
          (item, index) => (
            <Link
              key={item}
              onClick={handleNavClick} // ✅ سيتم إغلاق القائمة هنا
              className={activeviwo === item ? "active" : ""}
              to={item}
              spy={true}
              smooth={true}
              offset={-100}
              duration={200}
            >
              {item === "Home" && "الرئيسية"}
              {item === "About" && "من نحن؟"}
              {item === "Skills" && "مشاريعنا"}
              {item === "Blog" && "مدونتنا"}
              {item === "Services" && "خدماتنا"}
              {item === "Contact" && "تواصل معنا"}
            </Link>
          )
        )}
      </nav>

      {/* <div className={`toggle-mode ${isMobile ? "mobile-toggle" : ""}`}>
        <label>
          <input type="checkbox" onChange={toggelemode} />
          <i className="bx bxs-sun sun"></i>
          <i className="bx bxs-moon moon"></i>
          <span className="toggle"></span>
        </label>
      </div> */}
    </header>
  );
};

export default Nav;
